export const COMPACT_DIMENSIONS = {
  rowHeight: 48,
  headerHeight: 32,
};

export const EXPANDED_DIMENSIONS = {
  rowHeight: 156,
  headerHeight: 40,
};

export const NORMAL_DIMENSIONS = {
  fontSize: "14px",
  lineHeight: "1.5",
};

export const TABLE_STYLE_VARS = {
  headerBackgroundColor: "rgb(249 250 251)",
  headerForegroundColor: "rgb(75 85 99)",
  rowHoverColor: "rgb(249 250 251)",
  borderColor: "rgb(229 231 235)",
  cellHorizontalPadding: "12px",
  columnTransitionDuration: "250ms",
  columnTransitionTimingFunction: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
};

export const PAGINATION_PAGE_SIZES = [10, 25, 50];

export const DEFAULT_MIN_WIDTH = 100;
